import {
	Component,
	HostBinding,
	Input,
	OnInit
}                                         from '@angular/core';
import { BaseComponent }                  from '@app/core/bases/base-component/base.component';
import { IndicateElsterFieldContextEnum } from '@shared/directives/indicate-elster-field/indicate-elster-field.model';

@Component( {
	selector: 'app-label',
	templateUrl: './label.component.html',
	styleUrls: [ './label.component.scss' ]
} )
export class LabelComponent extends BaseComponent implements OnInit {

	private readonly _defaultCssClassList = 'col-12 pt-2';
	private readonly _inlineCssClassList = 'col-md-4 text-md-end';
	private readonly _spacingCssClass = 'mb-1';

	protected readonly indicateElsterFieldContextEnum = IndicateElsterFieldContextEnum;

	@Input() formControlInline = true;
	@Input() formEntityId: string;
	@Input() labelClassObject: object;
	@Input() labelFor: string;
	@Input() labelHostClassString: string;
	@Input() labelInfoInline = false;
	@Input() labelText: string;
	@Input() labelTitle: string;
	@Input() required: boolean;
	@Input() requiredByElster: boolean;
	@Input() showElsterIndicator: boolean = false;

	@HostBinding( 'class' ) baseCssClassList;


	constructor() {
		super();
	}

	ngOnInit(): void {
		this.labelFor = this.labelFor ? this.labelFor : this.formEntityId;
		if ( !this.labelTitle ) {
			this.labelTitle = this.labelText;
		}

		if ( this.labelHostClassString ) {
			this.baseCssClassList = `${ this._defaultCssClassList } ${ this.labelHostClassString }`;
			return;
		}

		this.baseCssClassList =
			`${this._defaultCssClassList} ${ this.formControlInline ? this._inlineCssClassList : this._spacingCssClass }`;

	}
}
